import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function stripLang(pathname) {
  return pathname.replace(/^\/(ar|en)/, "") || "/";
}

/**
 * Scrolls to the top on route changes, but stays in place when only the
 * language prefix changes (language switch).
 */
export default function ScrollToTop() {
  const location = useLocation();
  const prevRoute = useRef(null);

  useEffect(() => {
    const route = stripLang(location.pathname);
    const isLanguageSwitchOnly = prevRoute.current !== null && prevRoute.current === route;
    prevRoute.current = route;
    if (isLanguageSwitchOnly) return;
    if (location.state && location.state.scrollTo) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.state]);

  return null;
}
